export default __webpack_public_path__ + "static/media/product1.9893487d.png";